<div class="interaction-bar-wrapper">
  <div class="interaction-bar-title">
    @if (!editView) {
      Add Property
    }
    @if (editView) {
      Edit Property
    }
  </div>
  <app-add-property-view class="add-property-view" [editedProperty]="data"></app-add-property-view>
</div>
